import React, { useState, useEffect, Component } from 'react';
import { PageView, ModalView, Event } from "../GoogleAnalytics";
import { Spinner, Image } from 'react-bootstrap';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActionArea } from '@mui/material';
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { Cell, ResponsiveContainer, Legend, PieChart, Pie} from 'recharts';
import BasicHighchartGraph from '../Graph/BasicHighchartGraph';
import {
    AlertTypeIdsEnum,
    assetType,
    assetTypeStrings,
    Equipment,
    timeframeKeys,
    timeframeStrings
} from "../../componentObjects";
import FalsePositiveTypeModal from './FalsePositiveTypeModal';
import MonthSummaryModal from './MonthSummaryModal';
import AgeOfUnitsModal from './AgeOfUnitsModal';
import moment, {months} from 'moment';
import { COLORS } from "../../componentObjects";
import DatePicker from 'react-datepicker';
import triageService from "../../services/triage.service";
import assetService from '../../services/asset.service';
import Loader from "../Loader/Loader";
import alertsService from "../../services/alerts.service";
import CardLoader from "../Loader/CardLoader";
import PieChartCard from "./PieChartCard";
import CommentsService from "../../services/comments.service";
import alerttypemessagingService from "../../services/alerttypemessaging.service";
import AlertService from "../../services/alerts.service";
import {useNavigate} from "react-router-dom";
import SmallDashboardCard from "./SmallDashboardCard";
import dailyStatisticsService from "../../services/dailyStatistics.service";

const JOB_VALUE = 136.1;
const POOR_EVENT_SEGMENTATION = "Poor Event Segmentation";

const missTrackingTypes = [
    {
        alertTypeId: 13,
        alertTypeName: "Blower Failure"
    },
    {
        alertTypeId: 33,
        alertTypeName: "Abnormal Run"
    },
    {
        alertTypeId: 40,
        alertTypeName: "Pulse"
    },
    {
        alertTypeId: 42,
        alertTypeName: "Ignition Failure"
    },
    {
        alertTypeId: 43,
        alertTypeName: "Shutdown Failure"
    },
    {
        alertTypeId: 44,
        alertTypeName: "Induction Failure"
    },
    {
        alertTypeId: 45,
        alertTypeName: "Blower Cap Failure"
    },
    {
        alertTypeId: 46,
        alertTypeName: "Induction Capacitor Failure"
    },
    {
        alertTypeId: 53,
        alertTypeName: "Compressor Fault"
    },
    {
        alertTypeId: 92,
        alertTypeName: "Contactor Fault"
    }
]

function AlertTriageDashboard(props) {
    const { classes, isLoading, setActivePath, _isMounted } = props;
    const history = useNavigate();
    const [isMounted, setIsMounted] = useState(false);
    const [metricsList, setMetricsList] = useState([]);
    const [dailyMetricsList, setDailyMetricsList] = useState([]);
    const [assetCountList, setAssetCountList] = useState([]);
    const [dashboardData, setDashboardData] = useState({});
    const [tileContent, setTileContent] = useState({});
    const [triageUserContent, setTriageUserContent] = useState([]);
    const [tagAlertsContent, setTagAlertsContent] = useState([]);
    const [runCountData, setRunCountData] = useState([]);
    const [tagAlertsLoading, setTagAlertsLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(true);
    const [contentLoading, setContentLoading] = useState(false);
    const [triageMetricsLoading, setTriageMetricsLoading] = useState(true);
    const [averageTimeLoading, setAverageTimeLoading] = useState(true);
    const [assetCountsLoading, setAssetCountsLoading] = useState(true);
    const [runCountsLoading, setRunCountsLoading] = useState(true);
    const [selectedAssetType, setSelectedAssetType] = useState(assetTypeStrings.ALL);
    const [selectedTimeframe, setSelectedTimeframe] = useState(timeframeStrings.twentyFourHrs);
    const [fpAssetType, setFpAssetType] = useState(assetTypeStrings.ALL);
    const [falsePositiveCounts, setFalsePositiveCounts] = useState({});
    const [pieChartData, setPieChartData] = useState({});
    const [activeIndex, setActiveIndex] = useState(null);
    const [falsePositiveStartTime, setFalsePositiveStartTime] = useState(moment().subtract(1, 'days').startOf('day'));
    const [falsePositiveEndTime, setFalsePositiveEndTime] = useState(moment());
    const [falsePositiveStartTimestr, setFalsePositiveStartTimestr] = useState(moment().utc().subtract(1, 'days').startOf('day'));
    const [falsePositiveEndTimestr, setFalsePositiveEndTimestr] = useState(moment().utc());
    const [searchChanged, setSearchChanged] = useState(false);
    const [pieChartLoading, setPieChartLoading] = useState(false);
    const [isShowFalsePositiveTypeModal, setIsShowFalsePositiveTypeModal] = useState(false);
    const [isShowDownloadSummaryModal, setIsShowDownloadSummaryModal] = useState(false);
    const [isShowDownloadAgeOfUnitsModal, setIsShowDownloadAgeOfUnitsModal] = useState(false);
    const [monthSummary, setMonthSummary] = useState([]);
    const [monthSummaryLoading, setMonthSummaryLoading] = useState(false);
    const [ageOfUnitsList, setAgeOfUnitsList] = useState([]);
    const [ageOfUnitsLoading, setAgeOfUnitsLoading] = useState(false);
    const [ageOfUnitsLoadingMessage, setAgeOfUnitsLoadingMessage] = useState("");
    const [openDownloadMenu, setOpenDownloadMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [pieDataLoading, setPieDataLoading] = useState(false);
    const [missVsFalsePositiveData, setMissVsFalsePositivePositiveData] = useState({});
    const [selectedMissVsFalsePositiveData, setSelectedMissVsFalsePositiveData] = useState({});
    const [selectedMissVsFalsePositiveType, setSelectedMissVsFalsePositiveType] = useState(missTrackingTypes[0]);
    const [missVsFalsePositiveIndex, setMissVsFalsePositiveIndex] = useState(null);
    const [missVsFalsePositiveCounts, setMissVsFalsePositiveCounts] = useState({});
    const [changedAlertTypeData, setChangedAlertTypeData] = useState({});
    const [changedAlertTypeCounts, setChangedAlertTypeCounts] = useState({});
    const [changedAlertTypeIndex, setChangedAlertTypeIndex] = useState(null);
    const [escalationsData, setEscalationsData] = useState({});
    const [escalationsCounts, setEscalationsCounts] = useState({});
    const [escalationsIndex, setEscalationsIndex] = useState(null);
    const [averageClearTime, setAverageClearTime] = useState(0);
    const [numAlertQuestions, setNumAlertQuestions] = useState(0);
    const [alertQuestionsLoading, setAlertQuestionsLoading] = useState(false);

    const onPieEnter = (data, index) => {
        setActiveIndex(index);
    };
    
    const onMissVsFalsePositivePieEnter = (data, index) => {
        setMissVsFalsePositiveIndex(index);
    };
    
    const onChangedAlertTypePieEnter = (data, index) => {
        setChangedAlertTypeIndex(index);
    }
    
    const onEscalationsPieEnter = (data, index) => {
        setEscalationsIndex(index);
    }

    const onChangeStart = (e) => {
        setFalsePositiveStartTime(moment(e).startOf('day'));
        setFalsePositiveStartTimestr(moment(e).utc().startOf('day'));
        setSearchChanged(true);
    }

    const onChangeEnd = (e) => {
        setFalsePositiveEndTime(moment(e).endOf('day'));
        setFalsePositiveEndTimestr(moment(e).utc().endOf('day'));
        setSearchChanged(true);
    }

    const updateSearch = () => {
        setPieChartLoading(true);
        setSearchChanged(false);
        populatePieChartData(fpAssetType);
    }

    const populateInfo = async () => {
        setContentLoading(true);
        if (_isMounted && isMounted) {
            await triageService.getaverageclearalerttime()
                .then(response => {
                    setAverageClearTime(response);
                    setAverageTimeLoading(false);
                })
                .catch(e => {
                    console.log(e);
                });
            await triageService.getsessiontriagemetrics()
                .then(response2 => {
                    setDailyMetricsList(response2.groupedByDay);
                    setTriageUserContent(response2.groupedByUser);
                    setMetricsList(response2.sessionList);
                    setTriageMetricsLoading(false);
                })
                .catch(e => {
                    console.log(e);
                });
            await triageService.getassetcounts()
                .then(response3 => {
                    setAssetCountList(response3);
                    setAssetCountsLoading(false);
                })
                .catch(e => {
                    console.log(e);
                });
            await dailyStatisticsService.getruncounts()
                .then(response4 => {
                    setRunCountData(response4.data);
                    setRunCountsLoading(false);
                    setTileContent(generatePastDayMetrics());
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
    
    const populateTagAlertData = () => {
        if (_isMounted && isMounted) {
            setTagAlertsLoading(true);
            alertsService.gettagalerts(process.env.REACT_APP_POOR_EVENT_SEGMENTATION_TAG_ID)
                .then(response2 => {
                    setTagAlertsContent(response2.data);
                    setTagAlertsLoading(false);
                })
                .catch(e => {
                    console.log(e);
                    setTagAlertsLoading(false);
                })
        }
    }

    const populateAlertQuestionsCount = () => {
        if (_isMounted && isMounted) {
            setAlertQuestionsLoading(true);
            let now = moment();
            let before = moment(now).add(-2, 'years');
            let nowStr = now.format();
            let beforeStr = before.format();

            let alertArgs = {
                alertTagIds: [],
                alertTypeIds: null,
                startTime: beforeStr,
                endTime: nowStr,
                isClosed: false,
                isActive: true,
                isMuted: false,
                parentAssetId: null
            }

            CommentsService.getassetcomments()
                .then(async response => {
                    let assetComments = response.data;
                    if (assetComments !== null && assetComments !== undefined && assetComments.length) {
                        assetComments = assetComments.filter(c => c.hasQuestion);
                    }

                    let questionArgs = {
                        assetComments: assetComments,
                        args: alertArgs
                    };
                    await AlertService.getquestionalertlist(questionArgs)
                        .then(response2 => {
                            let tempData = [];
                            for (let x in response2.data) {
                                if (response2.data.hasOwnProperty(x)) {
                                    let alert = response2.data[x];
                                    let tempObject = {
                                        alertId: alert.alertId,
                                        typeId: alert.typeId,
                                        typeName: alert.type,
                                        alertMessage: alert.message,
                                        severity: "Critical",
                                        alert: alert
                                    }
                                    tempData.push(tempObject);
                                }
                            }
                            consolidateAlerts(tempData);
                        })
                        .catch(e => {
                            console.log(e);
                        });
                })
                .catch(e => {
                    console.log(e);
                })
        }
    }

    function consolidateAlerts(alerts) {
        let distinctAlerts = [];

        for (let i = 0; i < alerts.length; i++) {
            let currAlert = alerts[i];

            if (!distinctAlerts.some(a => a.typeId === currAlert.typeId && a.alert.assetId === currAlert.alert.assetId)) {
                let assetTypeAlerts = alerts.filter(a => a.typeId === currAlert.typeId && a.alert.assetId === currAlert.alert.assetId);
                let alertConversationId = Math.max(...assetTypeAlerts.map(o => o.alert.conversationId));
                let alertCommentCount = assetTypeAlerts.find(a => a.alert.conversationId === alertConversationId);

                assetTypeAlerts.sort((a, b) => {
                    const startA = new Date(a.alert.startTime);
                    const startB = new Date(b.alert.startTime);
                    return startB - startA;
                });

                let distinctAlert = [...assetTypeAlerts][0];
                if (alertConversationId !== 0) {
                    distinctAlert.alert.conversationId = alertConversationId.toString();
                    distinctAlert.commentsCount = alertCommentCount.alert.conversationItemCount;
                    distinctAlert.alert.conversationItemCount = alertCommentCount.alert.conversationItemCount;
                }
                distinctAlerts = distinctAlerts.concat(distinctAlert);
            }
        }
        
        setNumAlertQuestions(distinctAlerts.length);
        setAlertQuestionsLoading(false);
    }

    const populatePieChartData = (fpAssetType = assetTypeStrings.ALL) => {
        if (_isMounted && isMounted) {
            var startStr = falsePositiveStartTimestr.format();
            var endStr = falsePositiveEndTimestr.format();
            PageView();
            triageService.gettriagefalsepositivecounts(startStr, endStr)
                .then(response => {
                    var topTen = [];
                    if (response.length > 0 ){
                        let sortedarray = response.sort((a,b) => b.alertTypeCount - a.alertTypeCount);
                   
                        for (let i = 0; i < sortedarray.length; i++) {
                            if (i > 9) break;
                            topTen[i] = response[i];
                        }
                    
                }
                    if (_isMounted && isMounted) {
                        setPieChartData(generatePieChartData(topTen, fpAssetType));
                        setFalsePositiveCounts(topTen);
                        setPieChartLoading(false);
                    }
                })
                .catch(e => {
                    console.log(e);
                    setPieChartLoading(false);
                });
        }
    }

    const populateTopPieChartsData = (fpAssetType = assetTypeStrings.ALL) => {
        if (_isMounted && isMounted) {
            setPieDataLoading(true);
            AlertService.getmissedpiechartdata()
                .then(response2 => {
                    let missVsFalsePositiveData = response2 !== null && response2 !== undefined && response2.data !== null && response2.data !== undefined ? response2.data : {};
                    let selectedMissVsFalsePositiveData = missVsFalsePositiveData[selectedMissVsFalsePositiveType.alertTypeId];

                    triageService.gettriagepiechartsdata()
                        .then(response => {
                            let changeTopTen = [];
                            let changedAlertTypes = response?.changedAlertTypes;
                            if (changedAlertTypes?.length > 0) {
                                let sortedarray = changedAlertTypes.sort((a,b) => b.alertTypeCount - a.alertTypeCount);

                                for (let i = 0; i < sortedarray.length; i++) {
                                    if (i > 9) break;
                                    changeTopTen[i] = changedAlertTypes[i];
                                }
                            }

                            let topTen = [];
                            let escalations = response?.escalationsByAlertType;
                            if (escalations?.length > 0 ){
                                let sortedarray = escalations.sort((a,b) => b.alertTypeCount - a.alertTypeCount);

                                for (let i = 0; i < sortedarray.length; i++) {
                                    if (i > 9) break;
                                    topTen[i] = escalations[i];
                                }

                            }

                            if (_isMounted && isMounted) {
                                setMissVsFalsePositivePositiveData(missVsFalsePositiveData)
                                setSelectedMissVsFalsePositiveData(generatePieChartData(selectedMissVsFalsePositiveData, fpAssetType));
                                setMissVsFalsePositiveCounts(selectedMissVsFalsePositiveData);

                                setChangedAlertTypeData(generatePieChartData(changeTopTen, fpAssetType));
                                setChangedAlertTypeCounts(changeTopTen);

                                setEscalationsData(generatePieChartData(topTen, fpAssetType));
                                setEscalationsCounts(topTen);
                                setPieDataLoading(false);
                            }
                        })
                        .catch(e => {
                            console.log(e);
                            setPieDataLoading(false);
                        });
                })
                .catch(e => {
                    console.log(e);
                    setPieDataLoading(false);
                })
            
        }
    }

    const populateMonthSummaryData = (month, year) => {
        setMonthSummaryLoading(true);
        if (_isMounted && isMounted) {
            PageView();
            triageService.getmonthlytriagereport(month, year)
                .then(response => {
                    if (_isMounted && isMounted) {
                        setMonthSummary(response);
                        setMonthSummaryLoading(false);
                    }
                })
                .catch(e => {
                    console.log(e);
                    setMonthSummaryLoading(false);
                });
        }
    }

    function getAgeInYears(dateString) {
        const installDate = new Date(dateString);
        const now = new Date();
        const ageInMilliseconds = now - installDate;
        const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
        return Math.floor(ageInYears);
      }

    const populateAgeOfUnitsReport = async () => {
        setAgeOfUnitsLoading(true);
        setAgeOfUnitsLoadingMessage("Retrieving Asset Types...");
        await assetService.getclasslist()
            .then(async (response) => {
                if (_isMounted && isMounted) {
                    let assetClassesTemp = response.data.filter(c => 
                        c.type === "Normal" && 
                        !c.name.toLowerCase().includes("life") && 
                        !c.name.toLowerCase().includes("batch")
                    );
                        let ageOfUnitsListTemp = [];
                        const promises = assetClassesTemp.map(async (assetType) => {
                            let ageOfUnitsObject = {
                                assetType: assetType.name,
                                zeroToFive: 0,
                                sixToTen: 0,
                                elevenToFifteen: 0,
                                sixteenPlus: 0,
                                total: 0
                            };
                            setAgeOfUnitsLoadingMessage("Querying Install Dates...");
                            await assetService.getinstallproperties(assetType.classId)
                                .then(response2 => {
                                    setAgeOfUnitsLoadingMessage("Loading " + assetType.name + " Unit Counts...");
                                    response2.data.forEach(item => {
                                        if (item.installationDateValue != item.lifepulseInstallDateValue){
                                            const age = getAgeInYears(item.installationDateValue);
                                            ageOfUnitsObject.total++;
                                        
                                            if (age >= 0 && age <= 5) {
                                                ageOfUnitsObject.zeroToFive++;
                                            } else if (age >= 6 && age <= 10) {
                                                ageOfUnitsObject.sixToTen++;
                                            } else if (age >= 11 && age <= 15) {
                                                ageOfUnitsObject.elevenToFifteen++;
                                            } else if (age >= 16) {
                                                ageOfUnitsObject.sixteenPlus++;
                                            }
                                        }
                                    });
                                    
                                })
                                .catch(e => {
                                    console.log(e);
                                });
                            return ageOfUnitsObject;
                        });

                        const results = await Promise.all(promises);

                        const totals = results.reduce((acc, obj) => {
                            for (const key in obj) {
                                if (key === 'assetType') continue;
                                if (acc.hasOwnProperty(key)) {
                                    acc[key] += obj[key];
                                } else {
                                    acc[key] = obj[key];
                                }
                            }
                            return acc;
                        }, {});
                        
                        totals.assetType = "Totals";
                        
                        results.push(totals);
                  
                        setAgeOfUnitsList(results);
                        setAgeOfUnitsLoadingMessage("");
                        setAgeOfUnitsLoading(false);
                }
            })
            .catch(e => {
                console.log(e);
                setMonthSummaryLoading(false);
            });
    }

    const generatePieChartData = (data, selectedAssetType = assetTypeStrings.ALL) => {
        if (selectedAssetType === assetTypeStrings.ALL){
            return data
        }
        else if (selectedAssetType === assetTypeStrings.FURNACE){
            return data.filter(item => item.assetTypeId === assetType.Furnace);
        }
        else if (selectedAssetType === assetTypeStrings.AC){
            return data.filter(item => item.assetTypeId === assetType.AirConditioner);
        }
        else if (selectedAssetType === assetTypeStrings.HEAT_PUMP) {
            return data.filter(item => item.assetTypeId === assetType.HeatPump);
        }
        else if (selectedAssetType === assetTypeStrings.AIR_HANDLER) {
            return data.filter(item => item.assetTypeId === assetType.AirHandler);
        }
        return data;
    }

    const groupDataByDay = (sessionData) => {
        let reducedData =  sessionData.reduce((result, obj) => {
            const { sessionDate, dailyId, furnaceAlertCount, airConditionerAlertCount, heatPumpAlertCount, airHandlerAlertCount } = obj;
            const key = `${dailyId}-${sessionDate}`;

            if (!result[key]) {
                result[key] = { sessionDate, dailyId, furnaceAlertCount, airConditionerAlertCount, heatPumpAlertCount, airHandlerAlertCount };
            } else {
                result[key].furnaceAlertCount += furnaceAlertCount;
                result[key].airConditionerAlertCount += airConditionerAlertCount;
                result[key].heatPumpAlertCount += heatPumpAlertCount;
                result[key].airHandlerAlertCount += airHandlerAlertCount;
            }

            return result;
        }, {});

        return Object.values(reducedData).map(group => ({
            sessionDate: group.sessionDate,
            dailyId: group.dailyId,
            furnaceAlertCount: group.furnaceAlertCount,
            airConditionerAlertCount: group.airConditionerAlertCount,
            heatPumpAlertCount: group.heatPumpAlertCount,
            airHandlerAlertCount: group.airHandlerAlertCount
        }));
    }
    
    const getRunCountList = (timeframe) => {
        let runCountList = [];
        if (runCountData !== null && runCountData !== undefined && Object.keys(runCountData).length > 0) {
            if (timeframe === timeframeStrings.thirtyDays) {
                runCountList = runCountData[timeframeKeys.thirtyDays];
            }
            else {
                runCountList = runCountData[timeframeKeys.sevenDays]; //still want seven days if 24 hours so we can get the last run value -> prevents falsely showing '0 runs'
            }
        }
        return runCountList !== null && runCountList !== undefined ? runCountList : [];
    }

    const generatePastDayMetrics = (assetType = assetTypeStrings.ALL, timeframe = timeframeStrings.twentyFourHrs) => {
        let runCountList = getRunCountList(timeframe);
        let furnaceRunData = runCountList?.filter(x => x.assetType === Equipment.FURNACE);
        let acRunData = runCountList?.filter(x => x.assetType === Equipment.AIR_CONDITIONER);
        let heatPumpData = runCountList?.filter(x => x.assetType === Equipment.HEAT_PUMP);
        let airHandlerData = runCountList?.filter(x => x.assetType === Equipment.AIR_HANDLER);

        let twentyFourHoursAgo = new Date();
        if (timeframe === timeframeStrings.twentyFourHrs) {
            twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - 24);
        }
        else if (timeframe === timeframeStrings.sevenDays) { 
            twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - (24*7));
        }
        else if (timeframe === timeframeStrings.thirtyDays) {
            twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - (24*30));
        }
        let assetCountLatest = assetCountList[assetCountList.length - 1];
        let alertCount = 0;
        let runCount = 0;
        if (timeframe === timeframeStrings.twentyFourHrs) {
            let furnRunCount = furnaceRunData !== null && furnaceRunData !== undefined && furnaceRunData.length > 0 ? furnaceRunData[furnaceRunData.length - 1].runs : 0;
            let acRunCount = acRunData !== null && acRunData !== undefined && acRunData.length > 0 ? acRunData[acRunData.length - 1].runs : 0;
            let hpRunCount = heatPumpData !== null && heatPumpData !== undefined && heatPumpData.length > 0 ? heatPumpData[heatPumpData.length - 1].runs : 0;
            let ahRunCount = airHandlerData !== null && airHandlerData !== undefined && airHandlerData.length > 0 ? airHandlerData[airHandlerData.length - 1].runs : 0;
            runCount = assetType === assetTypeStrings.ALL ? furnRunCount + acRunCount + hpRunCount + ahRunCount
                : assetType === assetTypeStrings.FURNACE ? furnRunCount
                    : assetType === assetTypeStrings.AC ? acRunCount
                        : assetType === assetTypeStrings.HEAT_PUMP ? hpRunCount
                            : assetType === assetTypeStrings.AIR_HANDLER ? ahRunCount : 0
        }
        else {
            runCount = assetType === assetTypeStrings.ALL ? furnaceRunData.reduce((sum, data) => sum + data.runs, 0) + acRunData.reduce((sum, data) => sum + data.runs, 0) + heatPumpData.reduce((sum, data) => sum + data.runs, 0) + airHandlerData.reduce((sum, data) => sum + data.runs, 0)
                : assetType === assetTypeStrings.FURNACE ? furnaceRunData.reduce((sum, data) => sum + data.runs, 0)
                    : assetType === assetTypeStrings.AC ? acRunData.reduce((sum, data) => sum + data.runs, 0)
                        : assetType === assetTypeStrings.HEAT_PUMP ? heatPumpData.reduce((sum, data) => sum + data.runs, 0)
                            : assetType === assetTypeStrings.AIR_HANDLER ? airHandlerData.reduce((sum, data) => sum + data.runs, 0) : 0;
        }
        let tileMetrics = {
            alerts: 0,
            escalations: 0,
            triageTime: 0,
            assets: 0,
            runs: Number.isNaN(runCount) ? 0 : runCount
        };

        let sessionsWithinLast24Hours = metricsList.filter(obj => {
            let sessionDateString = new Date(obj.sessionDateTime);
            if (sessionDateString >= twentyFourHoursAgo)
                return obj;
        });

        if (assetType === assetTypeStrings.ALL) {
            sessionsWithinLast24Hours.forEach(session => {
                tileMetrics.alerts += session.furnaceAlertCount + session.airConditionerAlertCount + session.heatPumpAlertCount + session.airHandlerAlertCount;
                tileMetrics.escalations += session.escalatedFurnaceAlertCount + session.escalatedAirConditionerAlertCount + session.escalatedHeatPumpAlertCount + session.escalatedAirHandlerAlertCount;
                tileMetrics.triageTime += session.sessionDurationMinutes;
            });
            tileMetrics.assets = assetCountLatest?.value;
        }
        else if (assetType === assetTypeStrings.FURNACE) {
            sessionsWithinLast24Hours.forEach(session => {
                if (session.furnaceAlertCount > 0) {
                    tileMetrics.alerts += session.furnaceAlertCount
                    tileMetrics.escalations += session.escalatedFurnaceAlertCount;
                    tileMetrics.triageTime += session.sessionDurationMinutes;
                }
            });
            tileMetrics.assets = assetCountList?.furnacesrunninganalytics !== undefined ? assetCountList?.furnacesrunninganalytics[assetCountList?.furnacesrunninganalytics.length - 1].Value : 0;
        }
        else if (assetType === assetTypeStrings.AC) {
            sessionsWithinLast24Hours.forEach(session => {
                if (session.airConditionerAlertCount > 0) {
                    tileMetrics.alerts += session.airConditionerAlertCount;
                    tileMetrics.escalations += session.escalatedAirConditionerAlertCount;
                    tileMetrics.triageTime += session.sessionDurationMinutes;
                }
            });
            tileMetrics.assets = assetCountList?.airconditionersrunninganalytics !== undefined ? assetCountList?.airconditionersrunninganalytics[assetCountList?.airconditionersrunninganalytics.length - 1].Value : 0;
        }
        else if (assetType === assetTypeStrings.HEAT_PUMP) {
            sessionsWithinLast24Hours.forEach(session => {
                if (session.heatPumpAlertCount > 0) {
                    tileMetrics.alerts += session.heatPumpAlertCount;
                    tileMetrics.escalations += session.escalatedHeatPumpAlertCount;
                    tileMetrics.triageTime += session.sessionDurationMinutes;
                }
            });
            tileMetrics.assets = assetCountList?.heatpumpsrunninganalytics !== undefined ? assetCountList?.heatpumpsrunninganalytics[assetCountList?.heatpumpsrunninganalytics?.length - 1].Value : 0;
        }
        else if (assetType === assetTypeStrings.AIR_HANDLER) {
            sessionsWithinLast24Hours.forEach(session => {
                if (session.airHandlerAlertCount > 0) {
                    tileMetrics.alerts += session.airHandlerAlertCount;
                    tileMetrics.escalations += session.escalatedAirHandlerAlertCount;
                    tileMetrics.triageTime += session.sessionDurationMinutes;
                }
            });
            tileMetrics.assets = assetCountList?.airhandlersrunninganalytics !== undefined ? assetCountList?.airhandlersrunninganalytics[assetCountList?.airhandlersrunninganalytics?.length - 1].Value : 0;
        }

        return tileMetrics;
    }

    const groupDataByUser = (sessionData) => {
        if (sessionData !== undefined) {

            let reducedData = sessionData.reduce((result, obj) => {
                const { userId, userName, sessionDurationMinutes, furnaceAlertCount, airConditionerAlertCount,
                    heatPumpAlertCount, airHandlerAlertCount, escalatedFurnaceAlertCount, escalatedAirConditionerAlertCount,
                    escalatedHeatPumpAlertCount, escalatedAirHandlerAlertCount, falsePositiveFurnaceAlertCount,
                    falsePositiveAirConditionerAlertCount, falsePositiveHeatPumpAlertCount, falsePositiveAirHandlerAlertCount } = obj;
                const key = `${userId}`;

                let alertCount = furnaceAlertCount + airConditionerAlertCount + heatPumpAlertCount + airHandlerAlertCount;
                let escalationCount = escalatedFurnaceAlertCount + escalatedAirConditionerAlertCount + escalatedHeatPumpAlertCount + escalatedAirHandlerAlertCount;
                let falsePositiveCount = falsePositiveFurnaceAlertCount + falsePositiveAirConditionerAlertCount + falsePositiveHeatPumpAlertCount + falsePositiveAirHandlerAlertCount;
                let otherCount = alertCount - escalationCount - falsePositiveCount;
                let triageTime = sessionDurationMinutes;
                if (!result[key]) {
                    result[key] =
                    {
                        userId, userName, triageTime,
                        alertCount, escalationCount, falsePositiveCount, otherCount
                    };
                } else {
                    result[key].userName = userName;
                    result[key].triageTime += triageTime;
                    result[key].alertCount += alertCount;
                    result[key].escalationCount += escalationCount;
                    result[key].falsePositiveCount += falsePositiveCount;
                    result[key].otherCount += otherCount;
                }

                return result;
            }, {});

            return Object.values(reducedData).map(group => ({
                userName: group.userName,
                triageTime: group.triageTime,
                alertCount: group.alertCount,
                escalationCount: group.escalationCount,
                falsePositiveCount: group.falsePositiveCount,
                otherCount: group.otherCount
            }));
        }
    }

    const getAlertChartData = (data) => {
        let chartDataList = [];

        if (data !== undefined && data.length && assetCountList !== undefined && assetCountList.length) {
            let filledData = fillMissingDates(data);
            let pointMoment = moment(data[0].sessionDate).add(moment().utcOffset() * -1, 'minutes').format("l")
            let dt = new Date(pointMoment);
            let pointStartMoment = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());

            let furnaceArr = filledData.map((item) => (item.furnaceAlertCount));
            const furnaceData = {
                name: `Furnace Alerts`,
                yAxis: 0,
                data: furnaceArr,
                color: '#176a95',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(furnaceData);

            let acArr = filledData.map((item) => (item.airConditionerAlertCount));
            const acData = {
                name: `AC Alerts`,
                yAxis: 0,
                data: acArr,
                color: 'red',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(acData);

            let heatPumpArr = filledData.map((item) => (item.heatPumpAlertCount));
            const heatPumpData = {
                name: `Heat Pump Alerts`,
                yAxis: 0,
                data: heatPumpArr,
                color: '#1faa0a',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(heatPumpData);

            let airHandlerArr = filledData.map((item) => (item.airHandlerAlertCount));
            const airHandlerData = {
                name: `Air Handler Alerts`,
                yAxis: 0,
                data: airHandlerArr,
                color: '#b67df3',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(airHandlerData);
            
            let alertsPerAssetArr = filledData.map((item) => {
                let matchingAssetCount = assetCountList.filter(a => new Date(item.sessionDate).toDateString() === new Date(a.date).toDateString());
                let assetCount = matchingAssetCount.length > 0 ? matchingAssetCount[0].value : assetCountList[0].value;
                let alertsPerAsset = Math.round(((item.furnaceAlertCount + item.airConditionerAlertCount) / assetCount) * 100) / 100;
                return alertsPerAsset;
            });

            const alertsPerAssetData = {
                name: `Alerts/Asset`,
                yAxis: 1,
                data: alertsPerAssetArr,
                color: 'orange',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(alertsPerAssetData);
        }

        return chartDataList;
    }

    const getRunChartData = (runCountStats) => {
        let chartDataList = [];

        if (dailyMetricsList !== undefined && dailyMetricsList.length) {
            let alertData = dailyMetricsList;

            let filledData = fillMissingDates(alertData);
            let pointMoment = moment(alertData[0].sessionDate).add(moment().utcOffset() * -1, 'minutes').format("l")
            let dt = new Date(pointMoment);
            let pointStartMoment = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());

            let furnaceArr = filledData.map((item) => (item.furnaceAlertCount));
            const furnaceData = {
                name: `Furnace Alerts`,
                yAxis: 0,
                data: furnaceArr,
                color: '#176a95',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(furnaceData);

            let furnaceRunsArr = runCountStats?.filter((item) => item.assetType === Equipment.FURNACE).map((item) => (item.runs));
            const furnaceRunData = {
                name: `Furnace Runs`,
                yAxis: 1,
                data: furnaceRunsArr,
                color: '#176a95',
                dashStyle: 'dot',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(furnaceRunData);

            let acArr = filledData.map((item) => (item.airConditionerAlertCount));
            const acData = {
                name: `AC Alerts`,
                yAxis: 0,
                data: acArr,
                color: 'red',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(acData);

            let acRunsArr = runCountStats?.filter((item) => item.assetType === Equipment.AIR_CONDITIONER).map((item) => (item.runs));
            const acRunData = {
                name: `AC Runs`,
                yAxis: 1,
                data: acRunsArr,
                color: 'red',
                dashStyle: 'dot',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(acRunData);

            let heatPumpArr = filledData.map((item) => (item.heatPumpAlertCount));
            const heatPumpData = {
                name: `Heat Pump Alerts`,
                yAxis: 0,
                data: heatPumpArr,
                color: '#33df19',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(heatPumpData);

            let heatPumpRunsArr = runCountStats?.filter((item) => item.assetType === Equipment.HEAT_PUMP).map((item) => (item.runs));
            const heatPumpRunData = {
                name: `Heat Pump Runs`,
                yAxis: 1,
                data: heatPumpRunsArr,
                color: '#33df19',
                dashStyle: 'dot',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(heatPumpRunData);

            let airHandlerArr = filledData.map((item) => (item.airHandlerAlertCount));
            const airHandlerData = {
                name: `Air Handler Alerts`,
                yAxis: 0,
                data: airHandlerArr,
                color: '#b67df3',
                dashStyle: 'solid',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(airHandlerData);

            let airHandlerRunsArr = runCountStats?.filter((item) => item.assetType === Equipment.AIR_HANDLER).map((item) => (item.runs));
            const airHandlerRunData = {
                name: `Air Handler Runs`,
                yAxis: 1,
                data: airHandlerRunsArr,
                color: '#b67df3',
                dashStyle: 'dot',
                type: 'line',
                pointStart: pointStartMoment,
                pointInterval: 24 * 3600 * 1000,
                opacity: 1,
                marker: {
                    enabledThreshold: 0
                }
            };
            chartDataList = chartDataList.concat(airHandlerRunData);
        }

        return chartDataList;
    }

    const getAssetCounts = (data) => {
        let combinedCounts = {};

        Object.keys(data).forEach(assetType => {
            data[assetType].forEach(entry => {
                let date = new Date(entry.Timestamp).toISOString().split('T')[0]; // Extract date from timestamp
                if (!combinedCounts[date]) {
                    combinedCounts[date] = { date: date, value: parseInt(entry.Value, 10) };
                } else {
                    combinedCounts[date].value += parseInt(entry.Value, 10);
                }
            });
        });

        // Convert combinedCounts object to an array of objects
        let result = Object.values(combinedCounts);
        return result;
    }

    function fillMissingDates(data) {
        const filledData = [];
        const startDate = new Date(data[0].sessionDate);
        const endDate = new Date(data[data.length - 1].sessionDate);
        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            const matchingData = data.find(item => new Date(item.sessionDate).toDateString() === currentDate.toDateString());
            if (matchingData) {
                filledData.push(matchingData);
            } else {
                filledData.push({ sessionDate: currentDate.toISOString(), furnaceAlertCount: 0, airConditionerAlertCount: 0, heatPumpAlertCount: 0, airHandlerAlertCount: 0 });
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return filledData;
    }

    const formatMinutes = (totalMinutes) => {
        if (totalMinutes == 0) return '0 m';
        const hours = Math.floor(totalMinutes / 60);
        const minutes = (totalMinutes % 60).toFixed(2);// ?

        let formattedTime = '';
        if (hours > 0) {
            formattedTime += `${hours} h`; // Pluralize "hour" if necessary
        }
        if (minutes > 0) {
            formattedTime += ` ${minutes} m`; // Pluralize "minute" if necessary
        }

        return formattedTime.trim(); // Trim any leading/trailing whitespace
    }

    const onAssetTypeChange = (e) => {
        let assetTypeValue = e.target.value
        setSelectedAssetType(assetTypeValue);
        setTileContent(generatePastDayMetrics(assetTypeValue, selectedTimeframe));
    }
    
    const onTimeFrameChange = (e) => {
        let timeframeValue = e.target.value;
        setSelectedTimeframe(timeframeValue);
        setTileContent(generatePastDayMetrics(selectedAssetType, timeframeValue));
    }

    const onFpAssetTypeChange = (e) => {
        let assetTypeValue = e.target.value
        setFpAssetType(assetTypeValue);
        setPieChartData(generatePieChartData(falsePositiveCounts, assetTypeValue));
    }
    
    const onChangeAlertType = (e) => {
        let alertTypeVal = e.target.value;
        let typeData = missVsFalsePositiveData[alertTypeVal];
        setSelectedMissVsFalsePositiveType(alertTypeVal);
        setSelectedMissVsFalsePositiveData(typeData);
    }

    const onAlertQuestionsClick = () => {
        Event("Alert Questions Count clicked", "User clicked button to go to Alert Questions page", "Alert Questions Count clicked");
        setActivePath("/alertQuestions");
        const location = {
            pathname: "/alertQuestions"
        }

        history(location);
    }

    const onTriageMetricsClick = () => {
        Event("Triage Metrics clicked", "User clicked button to go to Alert Triage Details page", "Triage Metrics clicked");
        setActivePath("/alertTriageDetails");
        const location = {
            pathname: "/alertTriageDetails"
        }

        history(location);
    }

    const onPieChartClick = () => {
        showFalsePositiveTypeModal();
    }

    const showFalsePositiveTypeModal = () => {
        setIsShowFalsePositiveTypeModal(!isShowFalsePositiveTypeModal);
    }

    const onDownloadSummaryClick = () => {
        showDownloadSummaryModal();
    }

    const onDownloadAgeOfUnitsClick = () => {
        showDownloadAgeOfUnitsModal();
    }

    const showDownloadAgeOfUnitsModal = () => {
        setOpenDownloadMenu(false);
        if(!isShowDownloadAgeOfUnitsModal){
            populateAgeOfUnitsReport();
        }
        setIsShowDownloadAgeOfUnitsModal(!isShowDownloadAgeOfUnitsModal);
    }

    const showDownloadSummaryModal = () => {
        setOpenDownloadMenu(false);
        if(!isShowDownloadSummaryModal){
            const now = new Date();
            const currentMonth = now.getMonth() + 1;
            const currentYear = now.getFullYear();
            populateMonthSummaryData(currentMonth, currentYear);
        }
        setIsShowDownloadSummaryModal(!isShowDownloadSummaryModal);
    }

    const handleDownloadMenu = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenDownloadMenu(!openDownloadMenu);
    }

    const handleCloseDownloadMenu = () => {
        setAnchorEl(null);
        setOpenDownloadMenu(false);
    }

    useEffect(() => {
        setIsMounted(true);

        if (!isLoading) {
            populatePieChartData();
            populateTopPieChartsData();
            populateInfo();
            populateTagAlertData();
            populateAlertQuestionsCount();
            setContentLoading(false);
        }

        return () => {
            setIsMounted(false);        
        };
    }, [isMounted]);

    const renderMetricsContent = () => {
        let triageUserMetrics = <div className="row no-gutters card-row margin-8-0">
            <div className="col min-height-40">
                <div className="margin-0-20">
                    <table className="width-100p margin-bottom-0">

                        <thead>
                        <tr className="alerts-table-row">
                            <th className="table-shrink text-left pad-top-0 pad-left-30 pad-right-30 pad-bottom-10">
                                NAME
                            </th>
                            <th className="table-shrink text-center pad-top-0 pad-left-0 pad-right-0 pad-bottom-10">
                                ALERTS TRIAGED
                            </th>
                            <th className="table-shrink text-left pad-top-0 pad-right-10 pad-bottom-10 pad-left-40">
                                TRIAGE TIME
                            </th>
                            <th className="table-shrink text-left pad-top-0 pad-right-10 pad-bottom-10 pad-left-40">
                                ESCALATIONS
                            </th>
                            <th className="table-shrink text-left pad-top-0 pad-right-10 pad-bottom-10 pad-left-40">
                                FALSE POSITIVES
                            </th>
                            <th className="table-shrink text-left pad-top-0 pad-right-10 pad-bottom-10 pad-left-40">
                                OTHER
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        {triageUserContent !== undefined && triageUserContent.map((user, index) =>
                                <tr key={user.userName} data={index} className="alerts-table-row">
                                    <td className="text-left pad-top-8 pad-right-3 pad-bottom-8 pad-left-30"> {user.userName} </td>
                                    <td className="text-center pad-8-3"> {user.alertCount} </td>
                                    <td className="text-center pad-8-3"> {formatMinutes(user.triageTime)} </td>
                                    <td className="text-center pad-8-3"> {user.escalationCount} </td>
                                    <td className="text-center pad-8-3"> {user.falsePositiveCount} </td>
                                    <td className="text-center pad-top-8 pad-right-3 pad-bottom-8 pad-left-40"> {user.otherCount} </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;

        let poorSegmentationMetrics = <div className="row no-gutters card-row margin-8-0">
            <div className="col min-height-40">
                <div className="margin-0-20">
                    <table className="width-100p margin-bottom-0">

                        <thead>
                        <tr className="alerts-table-row">
                            <th className="table-shrink text-left pad-top-0 pad-left-30 pad-right-30 pad-bottom-10">
                                ALERT ID
                            </th>
                            <th className="table-shrink text-left pad-top-0 pad-left-0 pad-right-0 pad-bottom-10">
                                ALERT TYPE
                            </th>
                            <th className="table-shrink text-center pad-top-0 pad-left-0 pad-right-0 pad-bottom-10">
                                MAC ID
                            </th>
                            <th className="table-shrink text-center pad-top-0 pad-right-0 pad-bottom-10 pad-left-0">
                                TAG ASSIGNED
                            </th>
                            <th className="table-shrink text-center pad-top-0 pad-right-10 pad-bottom-10 pad-left-40">
                                DATE ALERT ESCALATED
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        {tagAlertsContent !== undefined && tagAlertsContent.map((alert, index) =>
                            <tr key={alert.alertId} data={index} className="alerts-table-row">
                                <td className="text-left pad-top-8 pad-right-3 pad-bottom-8 pad-left-30"> {alert.alertId} </td>
                                <td className="text-left pad-8-3"> {alert.alertType} </td>
                                <td className="text-center pad-8-3"> {alert.macId} </td>
                                <td className="text-center pad-8-3">{POOR_EVENT_SEGMENTATION}</td>
                                <td className="text-center pad-top-8 pad-right-3 pad-bottom-8 pad-left-40"> {alert.escalatedDate} </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;

        let DailyStatsHeader =
                    <div className="margin-bottom-20 flex-spread">
                        <span className="select-message">Timeframe: <br />
                            <select className="asset-select-picker width-150" value={selectedTimeframe} onChange={onTimeFrameChange}>
                                {Object.keys(timeframeStrings).map(key => (
                                    <option key={key} value={timeframeStrings[key]}>{timeframeStrings[key]}</option>
                                ))}
                            </select>
                            </span>
                        <span className="select-message">Asset Type: <br />
                            <select className="asset-select-picker width-150 margin-right-15" value={selectedAssetType} onChange={onAssetTypeChange}>
                                {Object.keys(assetTypeStrings).map(key => (
                                    <option key={key} value={assetTypeStrings[key]}>{assetTypeStrings[key]}</option>
                                ))}
                            </select>
                        </span>
                    </div>;

        let startTime = falsePositiveStartTime.toDate();
        let endTime = falsePositiveEndTime.toDate();

        let falsePositiveDatePicker =
            <div className="alerts-tab-wrapper alerts-top-wrapper-0-30">
                <div className="pad-left-40 margin-5">
                    <div className="reactive-dashboard reactive-dashboard-justify">
                        <div className="reactive-dashboard margin-0-auto">
                                <span className="select-message">Asset Type: <br/>
                                        <select className="asset-select-picker width-150"
                                                value={fpAssetType}
                                                onChange={onFpAssetTypeChange}>
                                            {Object.keys(assetTypeStrings).map(key => (
                                                <option key={key}
                                                        value={assetTypeStrings[key]}>{assetTypeStrings[key]}</option>
                                            ))}
                                        </select>
                                </span>
                            <span>
                                                    <div className="text-center">
                                                        <div className="margin-left-10">Start Day:</div>
                                                        <DatePicker
                                                            customInput={<input className="txt-detail datepicker"
                                                                                disabled={false}/>}
                                                            id="startDate"
                                                            name="startDate"
                                                            selected={startTime}
                                                            onChange={date => {
                                                                onChangeStart(date);
                                                            }}
                                                            dateFormat="MM/dd/yyyy"
                                                            popperPlacement="top-end"
                                                            popperProps={{
                                                                positionFixed: true
                                                            }}
                                                        />
                                                    </div>
                                                </span>
                                                <span>
                                                    <div className="text-center">
                                                        <div className="margin-left-10">End Day:</div>
                                                        <DatePicker
                                                            customInput={<input className="txt-detail text-center min-width-200"
                                                                                disabled={false}
                                                                                />}
                                                            id="endDate"
                                                            name="endDate"
                                                            selected={endTime}
                                                            onChange={date => {
                                                                onChangeEnd(date);
                                                            }}
                                                            dateFormat="MM/dd/yyyy"
                                                            popperPlacement="top-end"
                                                            popperProps={{
                                                                positionFixed: true
                                                            }}
                                                        />
                                                    </div>
                                                </span>

                            <button className="secondary-btn btn-small alerts-tab-btn margin-top-10" onClick={updateSearch} disabled={!searchChanged}>Update Dates
                            </button>
                        </div>
                    </div>
                </div>
            </div>;


            let pieChart = pieChartLoading ?
                <div className="loading-wrapper top-25p">
                    <div className="modal-body"><Spinner animation="border" variant="dark"/></div>
                </div> 
                :
                <PieChart width={400} height={600} onMouseEnter={null} onClick={onPieChartClick}>
                    <Pie
                        data={pieChartData}
                        innerRadius={75}
                        outerRadius={125}
                        fill="#8884d8"
                        paddingAngle={5}
                        dataKey="alertTypeCount"
                        nameKey="alertTypeName"
                        opacity="65%"
                        label={true}
                        onMouseOver={onPieEnter}
                        isAnimationActive={false}
                    >
                        {pieChartData.length > 0 &&
                            (pieChartData.map((entry, index) => (
                                <Cell key={`cell-${index}`}
                                    fill={COLORS[index % COLORS.length]}
                                    stroke={activeIndex === index ? '#333' : 'none'}
                                    strokeWidth={activeIndex === index ? 2 : 0}/>
                            )))
                        }
                    </Pie>

                    <Legend verticalAlign="bottom" iconType="circle" iconSize={6}
                            wrapperStyle={{opacity: '75%', padding: '0px 10px'}}
                            onMouseEnter={onPieEnter}
                            formatter={(value, entry, index) => {
                                const activeStyle = {
                                    fontWeight: activeIndex === index ? 'bold' : 'normal',
                                    color: activeIndex === index ? COLORS[index % COLORS.length] : 'inherit'
                                };
                                return <span style={activeStyle}>{value}</span>;
                            }}
                    />
                </PieChart>

        let alertTypePicker =
            <div className="alerts-tab-wrapper alerts-top-wrapper-0-30">
                <div className="pad-left-40 margin-5">
                    <div className="reactive-dashboard reactive-dashboard-justify">
                        <div className="reactive-dashboard margin-0-auto">
                                <span className="select-message">Alert Type: <br/>
                                        <select className="asset-select-picker width-250"
                                                value={selectedMissVsFalsePositiveType}
                                                onChange={onChangeAlertType}>
                                            {missTrackingTypes.map(type => (
                                                <option key={type.alertTypeId}
                                                        value={type.alertTypeId}>{type.alertTypeName}</option>
                                            ))}
                                        </select>
                                </span>
                        </div>
                    </div>
                </div>
            </div>;

        let missVsFalsePositiveChart = pieDataLoading ?
            <CardLoader />
            :
            <div className={"justify-content-center display-flex"}>
                <PieChart width={400} height={300} onMouseEnter={null}>
                    <Pie
                        data={selectedMissVsFalsePositiveData}
                        innerRadius={40}
                        outerRadius={70}
                        fill="#8884d8"
                        paddingAngle={5}
                        dataKey="alertTypeCount"
                        nameKey="alertTypeName"
                        opacity="65%"
                        label={true}
                        onMouseOver={onMissVsFalsePositivePieEnter}
                        isAnimationActive={false}
                    >
                        {selectedMissVsFalsePositiveData?.length > 0 &&
                            (selectedMissVsFalsePositiveData?.map((entry, index) => (
                                <Cell key={`cell-${index}`}
                                      fill={COLORS[index % COLORS.length]}
                                      stroke={missVsFalsePositiveIndex === index ? '#333' : 'none'}
                                      strokeWidth={missVsFalsePositiveIndex === index ? 2 : 0}/>
                            )))
                        }
                    </Pie>

                    <Legend verticalAlign="bottom" iconType="circle" iconSize={6}
                            wrapperStyle={{opacity: '75%', padding: '0px 10px'}}
                            onMouseEnter={onMissVsFalsePositivePieEnter}
                            formatter={(value, entry, index) => {
                                const activeStyle = {
                                    fontWeight: missVsFalsePositiveIndex === index ? 'bold' : 'normal',
                                    color: missVsFalsePositiveIndex === index ? COLORS[index % COLORS.length] : 'inherit'
                                };
                                return <span style={activeStyle}>{value}</span>;
                            }}
                    />
                </PieChart>
            </div>

        let changedAlertTypeChart = pieDataLoading ?
            <CardLoader />
            :
            <PieChart width={200} height={500} onMouseEnter={null}>
                <Pie
                    data={changedAlertTypeData}
                    innerRadius={50}
                    outerRadius={90}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="alertTypeCount"
                    nameKey="alertTypeName"
                    opacity="65%"
                    label={true}
                    onMouseOver={onChangedAlertTypePieEnter}
                    isAnimationActive={false}
                >
                    {changedAlertTypeData.length > 0 &&
                        (changedAlertTypeData.map((entry, index) => (
                            <Cell key={`cell-${index}`}
                                  fill={COLORS[index % COLORS.length]}
                                  stroke={changedAlertTypeIndex === index ? '#333' : 'none'}
                                  strokeWidth={changedAlertTypeIndex === index ? 2 : 0}/>
                        )))
                    }
                </Pie>

                <Legend verticalAlign="bottom" iconType="circle" iconSize={6}
                        wrapperStyle={{opacity: '75%', padding: '0px 10px'}}
                        onMouseEnter={onChangedAlertTypePieEnter}
                        formatter={(value, entry, index) => {
                            const activeStyle = {
                                fontWeight: changedAlertTypeIndex === index ? 'bold' : 'normal',
                                color: changedAlertTypeIndex === index ? COLORS[index % COLORS.length] : 'inherit'
                            };
                            return <span style={activeStyle}>{value}</span>;
                        }}
                />
            </PieChart>

        let escalationsChart = pieDataLoading ?
            <CardLoader/>
            :
            <PieChart width={200} height={500} onMouseEnter={null}>
                <Pie
                    data={escalationsData}
                    innerRadius={50}
                    outerRadius={90}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="alertTypeCount"
                    nameKey="alertTypeName"
                    opacity="65%"
                    label={true}
                    onMouseOver={onEscalationsPieEnter}
                    isAnimationActive={false}
                >
                    {escalationsData.length > 0 &&
                        (escalationsData.map((entry, index) => (
                            <Cell key={`cell-${index}`}
                                  fill={COLORS[index % COLORS.length]}
                                  stroke={escalationsIndex === index ? '#333' : 'none'}
                                  strokeWidth={escalationsIndex === index ? 2 : 0}/>
                        )))
                    }
                </Pie>

                <Legend verticalAlign="bottom" iconType="circle" iconSize={6}
                        wrapperStyle={{opacity: '75%', padding: '0px 10px'}}
                        onMouseEnter={onEscalationsPieEnter}
                        formatter={(value, entry, index) => {
                            const activeStyle = {
                                fontWeight: escalationsIndex === index ? 'bold' : 'normal',
                                color: escalationsIndex === index ? COLORS[index % COLORS.length] : 'inherit'
                            };
                            return <span style={activeStyle}>{value}</span>;
                        }}
                />
            </PieChart>;
        
        let assetChart = triageMetricsLoading ?
            <div className={"row justify-content-center"}>
                <div className="dot-flashing"></div>
            </div>
            : <BasicHighchartGraph chartData={getAlertChartData(dailyMetricsList)} yAxisTitle='Alerts' yAxisTitle2='Alerts/Assets' />;
        
        let runChart = triageMetricsLoading || runCountsLoading ?
            <div className={"row justify-content-center"}>
                <div className="dot-flashing"></div>
            </div>
            : runCountData !== null && runCountData !== undefined && runCountData[timeframeKeys.thirtyDays].length ? 
                <BasicHighchartGraph chartData={getRunChartData(runCountData[timeframeKeys.thirtyDays])} yAxisTitle='Alerts' yAxisTitle2='Runs' /> 
                : null;
        
        let triageUserMetricsContent = triageMetricsLoading ?
            <div className={"row justify-content-center"}>
                <div className="dot-flashing"></div>
            </div>
            : triageUserMetrics;
        
        let metricsForTiles = generatePastDayMetrics(selectedAssetType, selectedTimeframe);

        return (
            <div>
                <div className="row pad-left-30 pad-right-30 pad-top-20">
                    
                    <div className="col-md-4">
                        <PieChartCard title={"Miss vs. False Positives (All Time)"} pieChartContent={missVsFalsePositiveChart} bottomContent={alertTypePicker} height={325} />
                    </div>

                    <div className="col-md-4">
                        <PieChartCard title={"Changed Alert Types (All Time)"} pieChartContent={changedAlertTypeChart} bottomContent={null} height={400} />
                    </div>

                    <div className="col-md-4">
                        <PieChartCard title={"Escalations by Alert Type (All Time)"} pieChartContent={escalationsChart} bottomContent={null} height={400} />
                    </div>
                    
                </div>
                
                
                <div className="row pad-30">

                    <div className="col-lg-8 col-md-6 margin-bottom-20 display-inline">
                        <div>

                            <div className="row no-gutters margin-bottom-20">
                                <div className="col">

                                    <Card elevation={4} className="height-100p">
                                        <CardActionArea className="height-100p">
                                            <CardContent className="pad-10-0">

                                                <h6 className="pad-left-15">Alerts Report (since {moment().add(-30, 'days').format("MM/DD/YYYY")})</h6>
                                                <div className="row no-gutters card-row min-height-110">
                                                    <div className="col min-height-110">
                                                        {assetChart}
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </div>
                            </div>

                            <div className="row no-gutters margin-bottom-20">
                                <div className="col">

                                    <Card elevation={4} className="height-100p">
                                        <CardActionArea className="height-100p">
                                            <CardContent className="pad-10-0">

                                                <h6 className="pad-left-15">Runs Report (since {moment().add(-30, 'days').format("MM/DD/YYYY")})</h6>
                                                <div className="row no-gutters card-row min-height-110">
                                                    <div className="col min-height-110">
                                                        {runChart}
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </div>
                            </div>

                            <div className="row no-gutters margin-bottom-20" onClick={onTriageMetricsClick}>
                                <div className="col">

                                    <Card elevation={4} className="height-100p">
                                        <CardActionArea className="height-100p">
                                            <CardContent className="pad-10-0">

                                                <h6 className="pad-left-15">Triage User Metrics (Last 24 hrs)</h6>
                                                <div className="row no-gutters card-row min-height-110">
                                                    <div className="col min-height-110">
                                                        {triageUserMetricsContent}
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </div>
                            </div>

                            <div className="row no-gutters margin-bottom-20">
                                <div className="col">
                                    <Card elevation={4} className="height-100p">
                                        <CardContent className="pad-10-0">
                                            <h6 className="pad-left-15">Total Alerts Triaged (by adjustable date range)</h6>

                                            <ResponsiveContainer height={500}>
                                                {pieChart}
                                            </ResponsiveContainer>
                                            <br />
                                            {falsePositiveDatePicker}
                                        </CardContent>
                                    </Card>
                                </div>
                            </div>

                            <div className="row no-gutters margin-bottom-20">
                                <div className="col">

                                    <Card elevation={4} className="height-100p">
                                        <CardActionArea className="height-100p">
                                            <CardContent className="pad-10-0">

                                                <h6 className="pad-left-15">Poor Event Segmentation Alerts (Currently Open)</h6>
                                                <div className="row no-gutters card-row min-height-110">
                                                    <div className="col min-height-110">
                                                        {poorSegmentationMetrics}
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 display-inline">
                        <div>
                            <div className="row height-100p">
                                <div className="col-12 display-grid">
                                    <Card elevation={4} className="card-background">
                                        <CardContent className="pad-10-0">
                                            {DailyStatsHeader}

                                            <div className="col-12 display-grid">
                                                <div>
                                                    <SmallDashboardCard title={"Escalations"} content={metricsForTiles.escalations} onClick={null} isRed={true} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Alerts"} content={metricsForTiles.alerts} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Asset Count"} content={metricsForTiles.assets} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Runs"} content={parseInt(metricsForTiles.runs, 10).toLocaleString()} onClick={null} loading={triageMetricsLoading || assetCountsLoading || runCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Triage Time"} content={formatMinutes(metricsForTiles.triageTime)} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Assets/FTE (90%)"} content={(((432 / metricsForTiles.triageTime) * metricsForTiles.assets).toFixed(0)).toLocaleString()} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Assets/FTE (100%)"} content={(((480 / metricsForTiles.triageTime) * metricsForTiles.assets).toFixed(0)).toLocaleString()} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Alerts / Assets"} content={(metricsForTiles.alerts / metricsForTiles.assets).toFixed(2)} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Escalations / Alert"} content={<div>{((metricsForTiles.escalations / metricsForTiles.alerts) * 100).toFixed(2)}%</div>} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Customer Revenue"} content={`$${((JOB_VALUE * metricsForTiles.escalations * 0.85) + (5 * metricsForTiles.escalations / 2)).toFixed(2)}`} onClick={null} loading={triageMetricsLoading || assetCountsLoading}/>
                                                    
                                                    <SmallDashboardCard title={"Active Alert Questions"} content={numAlertQuestions} onClick={onAlertQuestionsClick} loading={alertQuestionsLoading} />
                                                    
                                                    <SmallDashboardCard title={"Avg Time To Clear Alerts"} content={`${averageClearTime} minutes`} onClick={null} loading={averageTimeLoading} />
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    let content = contentLoading ?
        <Loader />
        : renderMetricsContent();

    return (

        <div sx={(theme)=>({
            [theme.breakpoints.down('md')]: {
                marginLeft: '-225px !important',
            },
        })}>
            <div className='infoPage'>
                <div className="row no-gutters">
                    <div className="col">
                        <h2 className="pageTitle pageTitle-border-none" id="tabelLabel">
                            Alert Triage Dashboard
                        </h2>
                    </div>
                    <div className="col flex-end">
                        <button className="primary-btn btn-large width-250" onClick={handleDownloadMenu}>Download Reports</button>
                        <Menu
                            id="menu-download"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={openDownloadMenu}
                            onClose={handleCloseDownloadMenu}
                        >
                            <MenuItem onClick={onDownloadSummaryClick}>Monthly Triage Summary</MenuItem>
                            <MenuItem onClick={onDownloadAgeOfUnitsClick}>Age of Units Report</MenuItem>
                        </Menu>
                    </div>
                </div>
                {content}
                <FalsePositiveTypeModal show={isShowFalsePositiveTypeModal} onClick={showFalsePositiveTypeModal} loading={pieChartLoading} selectedAssetType={fpAssetType} fpData={pieChartData} startTime={falsePositiveStartTime} endTime={falsePositiveEndTime}> </FalsePositiveTypeModal>
                <MonthSummaryModal show={isShowDownloadSummaryModal} onClick={showDownloadSummaryModal} updateData={populateMonthSummaryData} loading={monthSummaryLoading} monthData={monthSummary}> </MonthSummaryModal>
                <AgeOfUnitsModal show={isShowDownloadAgeOfUnitsModal} onClick={showDownloadAgeOfUnitsModal} updateData={populateMonthSummaryData} loading={ageOfUnitsLoading} loadingMessage={ageOfUnitsLoadingMessage} ageData={ageOfUnitsList}> </AgeOfUnitsModal>
            </div>
        </div>
    );
}

export default AlertTriageDashboard;
